import { kea } from 'kea'
import PropTypes from 'prop-types'
import {find, get, map, omit, filter, compact} from 'lodash'
import {put, call, all, select} from 'redux-saga/effects'

import { Products, CartItems, Carts } from '@gratify-eu/entities'
import { selector as configSelector } from '~/config'

import entities from '~/entities'
import {actions as configActions} from "~/config";

export default kea({
  key : (props) => {
    const { id, gfyPlugin } = props;

    return `${gfyPlugin}-${id}`
  },

  path: (key) => {
    return ['plugins', 'buy-button', key];
  },

  actions: ({ constants }) => ({
    addToCart: (product) => ({product}),
    loading: (productId) => ({productId}),
    loadSuccess: (product) => ({product}),
    loadFailed: true,
    setExtraProducts: (productIds) => ({productIds})
  }),

  reducers: ({ actions, constants }) => ({
    loading: [false, PropTypes.bool, {
      [actions.loading]: () => true,
      [actions.loadSuccess]: () => false,
      [actions.loadFailed]: () => false,
    }],
    failed: [false, PropTypes.bool, {
      [actions.loadFailed]: () => true,
    }],
    extraProductsToAddState: [[], PropTypes.array, {
      [actions.setExtraProducts]: (_, payload) => {
        return payload.productIds || [];
      },
    }]
  }),

  selectors : ({ constants, selectors }) => ({
    product: [
      () => [
        entities.selectors.products,
        (state, props) => props.productId
      ], (products, productId) => {
        if (productId) {
          const product = find(products, {id: productId});

          if (product) {
            return product;
          }
        }

        return null;
      },
      PropTypes.object
    ],

    hasQuantity: [
      () => [
        selectors.product
      ], (product) => {
        if(product) {
          const quantity = get(product, 'features.quantity')
          if(typeof quantity !== 'undefined') {
            return quantity > 0;
          }
        }

        return true
      },
      PropTypes.bool
    ],

    extraProductsToAdd: [
      () => [
        selectors.extraProductsToAddState,
        entities.selectors.products
      ], (extraProducts, allProducts) => {
        if(extraProducts && extraProducts.length > 0) {
          return compact(map(extraProducts, (productId) => {
            return find(allProducts, {id: productId}) || null;
          }))
        }
        return [];
      },
      PropTypes.array
    ]
  }),

  start: function* () {
    yield call(this.workers.fetchData);
  },

  takeLatest: ({ actions, workers }) => ({
    [actions.addToCart]: workers.addToCart,
    [CartItems.actions.create.failure]: workers.addToCartFailure,
    [CartItems.actions.update.failure]: workers.addToCartFailure,
  }),

  workers: {
    fetchData: function* () {
      const { loading, loadSuccess, loadFailed, setExtraProducts } = this.actionCreators;
      const { productId, extraProducts } = this.props;
      yield put(loading(productId));

      let extraProductsToAdd = [];
      let result;
      try {
        result = yield call(Products.workers.fetch, {payload: {id: productId}}, true);

        if(extraProducts) {
          const extraProductIds = extraProducts.split(',')

          try {
            extraProductsToAdd = yield all(map(extraProductIds, (product) => { return call(Products.workers.fetch, {payload: {id: product}}, true) }));
            extraProductsToAdd = filter(extraProductsToAdd, (product) => (!!get(product, 'id')));
            yield put(setExtraProducts(map(extraProductsToAdd, 'id')));
          } catch(e) {
          }
        }

        if(result) {
          yield put(loadSuccess(result));
        }else {
          yield put(loadFailed())
        }
      } catch (e) {
        yield put(loadFailed())
      }
    },

    addToCart: function* (action) {
      const { product } = action.payload || {};

      const activeCart = yield entities.get('activeCart');
      const activeShop = yield entities.get('activeShop');
      const extraProducts = yield this.get('extraProductsToAdd');

      if(product) {
        if(activeCart) {
          yield all(map([product, ...extraProducts], (product) => {
            const cartItem = find(activeCart.contents, {product: product.url});

            if(cartItem) {
              // item exists
              const updatedCartItem = {
                quantity: cartItem.quantity + 1
              };
              return put(CartItems.actions.update.request(cartItem.id, updatedCartItem));
            }else {
              const newCartItem = {
                product: product.url,
                quantity: 1,
                cart: activeCart.url
              };
              return put(CartItems.actions.create.request(newCartItem));
            }
          }));
        } else {
          const config  = yield select(configSelector);

          let newCartDefaults = {};
          try {
            if(config && config.cartDefaults && config.cartDefaults) {
              newCartDefaults = omit(config.cartDefaults, ['contact', 'shipping_contact']);
            }
          } catch (e) {
            console.error(e);
          }

          const newCart = {
            ...newCartDefaults,
            shop: activeShop.url,
            contents: map([product, ...extraProducts], (product) => {
              return {product: product.url, quantity: 1};
            }),
          };

          yield put(Carts.actions.create.request(newCart))
        }
      }

    },

    addToCartFailure: function* (action) {
      try {
        const { message: {non_field_errors}} = action.payload

        if(non_field_errors[0] === 'invalid_cart') {
          yield put(configActions.clearActiveCart());
        }
      } catch (e) {

      }
    }
  }
})
